<template>
  <Consultation />
</template>

<script>
import Consultation from "../../components/Consultation";
export default {
  components: {
    Consultation,
  },
};
</script>

<style>
</style>